<section class="ui_tablebox" :style="`max-height: ${tableScrollHeight} `" :class="{'scroll': tableScrollHeight}">
  <!-- <div>{{state.checkDataList.length}}</div>
  <div>isCheckAll : {{state.isCheckAll}}</div>
  <div>allCheck : {{state.allCheck}}</div>
  <div>dataCheck : {{state.dataCheck}}</div>
  <div>{{dropdown}}</div> -->
  <!-- <div>columns : {{columns}}</div> -->
  <!-- <div>dropdown : {{dropdown}}</div> -->
  <table class="tableBlock" ref="root">
    <thead class="columns">
      <tr>
        <td v-if="dropdown" width="1px"></td>
        <td v-if="checkBox" class="checkBoxTr" width="1px" :class="{'paddingNone': dropdown && checkBox}">
          <Checkbox v-model:isCheck="state.allCheck" @click="beforeChange('all')"  size="sm"
          @keypress.enter="beforeChange('all')" 
            value="all"></Checkbox>
          </td>
        <td v-for="(col, i ) in columns" :width="col.width" @click='tdSort(i,col)'
          :class="{'tdSelect': state.selected == i &&  col.sort ,'cursor': col.sort ,'padding_0': col.sort }"
          :style="style"
          :tabindex="col.sort ? 0 : -1" @keypress.enter="tdSort(i,col)">
          <slot :name="col.customRender+'th'" v-if="col.customRender" :index="i" :title="col.title"></slot>
          <span v-else class="tdBlock">
            {{col.title}}
            <span v-if="col.sort">
              <img :src="require('@/assets/images/asus_proart_sw_ico_sort_up_on.png')" alt="" class="pressed"
                :class="{'sortShow': state.sorting[i]}">
              <img :src="require('@/assets/images/asus_proart_sw_ico_sort_down_on.png')" alt="" class="normal"
                :class="{'sortShow':  !state.sorting[i]}">
            </span>
          </span>
        </td>
      </tr>
    </thead>
    <tbody v-for="(row,rowIndex) in state.dataList" v-if="state.dataList.length" class="datas"
      @contextmenu.native="showContextMenu($event, row ,rowIndex)" 
      :class="{'hasHoverEffect': disableCheck ? !disableCheck[rowIndex] : true}">
      <tr>

        <td class="iconTr" v-if="dropdown" :class="{'paddingNone': (dropdown==true)  && (checkBox == true)}">
          <div @click="extend(rowIndex)" :class="{'active': state.taleExtend[rowIndex]}" 
          :tabindex="dropdown ? 0 : -1" @keypress.enter="dropdown ? extend(rowIndex) : ()=>{}">
            <iCon v-if="typeof dropdown == 'string' && row[dropdown]" iconClass="dropdown" class="icon"></iCon>
            <div v-else></div>
          </div>

        </td>

        <td v-if="checkBox" class="checkBoxTr" :class="{'paddingNone': dropdown && checkBox}">
          <Checkbox v-model:isCheck="state.dataCheck[rowIndex]" :isDisable="state.disableList[rowIndex]"
            @click="beforeChange('each')" @onChange="checkOnChange" :value="rowIndex.toString()" :key="'each'+rowIndex"
            size="sm"
            @keypress.enter="beforeChange('each') "></Checkbox>
          </td>

        <td v-for="(col,colIndex) in columns"
          :style="`padding-left: ${tablePadding}px ; padding-right: ${tablePadding}px ; text-align : ${col.align}`"
          @mouseover="hoverEffect($event,col,row[col.key] ,rowIndex, colIndex)"
          @mouseleave="hoverEffect($event,col,'s')" :class="tdStyle(col,row[col.key])">
          <slot :name="col.customRender" :text="row[col.key]" :data="row" :index="rowIndex" :col="col"
            v-if="col.customRender">
          </slot>
          
          <iCon :iconClass="col.clickPopUpIcon" v-if="col.clickPopUp  && row[col.key]" class="clickPopUpIcon"
            :class="{'active': rowIndex == state.clickIndex }" @click.stop="clickPopUpEffect(col ,rowIndex ,row)"
            :tabindex="col.clickPopUp ? 0 : -1" @keypress.enter="clickPopUpEffect(col ,rowIndex ,row)"
            >
          </iCon>

          <span v-if="!col.customRender && !col.color" :class="styleInit(col,row[col.key],rowIndex)" @click="goLink(col,row,rowIndex)" 
          :tabindex="col.isLink ? 0 : -1" @keypress.enter="goLink(col,row,rowIndex)"
            class="normalTd ">{{row[col.key]}}
          </span>
          <span v-if="col.color" :class="styleInit(col,row[col.key],rowIndex)" @click="goLink(col,row,rowIndex)" 
          :tabindex="col.isLink ? 0 : -1" @keypress.enter="goLink(col,row,rowIndex)">
            <span v-if="col.colorRange">{{row[col.key]}} </span>
            <span v-if="!col.colorRange">
              <span  v-if="row[col.key] < 999">
                {{ col.isI18n ? t(col.isI18n[row[col.key]]) :  row[col.key]}}
                <!-- {{ col.isI18n ? t(col.isI18n[row[col.key]]) :  col.colorEnum ? col.colorEnum[row[col.key]] : row[col.key]}} -->
              </span>
              <span v-if="row[col.key] == 999">
                <slot :name="'custom'" :data="row" :index="rowIndex" :col="col" :title="col.isI18n" :text="row[col.key]"></slot>
              </span>
            </span>
          </span>
          <span v-if="( (!row[col.key] && row[col.key] !== 0) && !col.customRender)  ">- - -</span>

          <!-- <div class="textLimitHoverBlock" v-if="state.hoverCol == colIndex && state.hoverRow == rowIndex && col.textLimit && row[col.key] == state.mouseOver && (row[col.key] || row[col.key] == 0)"
            :class="{'opacity': col.textLimit && row[col.key] == state.mouseOver}">{{state.mouseOver}}</div> -->

          <div class="textLimitHoverBlock"
            v-if="state.hoverCol == colIndex && state.hoverRow == rowIndex && dotInfo && row[col.key] == state.mouseOver && (row[col.key] || row[col.key] == 0) "
            :class="{'opacity': dotInfo && row[col.key] == state.mouseOver, 'rightPosition': colIndex = columns.length-1 }">{{state.mouseOver}}</div>


          <div class="clickPopUpBlock" v-if="col.clickPopUp  && row[col.key]" v-click-outside="handleFocusOut" :class="[{'opacity': col.clickPopUp && rowIndex == state.clickIndex } 
            ,( rowIndex== state.clickIndex) ?'show':'noshow']">
            <div v-for=" ( e,index) in state.clickContent">
              <span class="clickPopUp_number_color">{{index+1}}.</span> {{e}}
            </div>
          </div>
        </td>
      </tr>


      <tr class="slot">
        <!-- <td :colspan="emptyTr" class="empty"></td>  前面要有空間的話這個打開-->
        <td :colspan="columns.length + emptyTr">
          <div class="second" :class="{'show': state.taleExtend[rowIndex]}">
            <slot :name="'second'" :data="row" :index="rowIndex"></slot>
          </div>
        </td>
      </tr>

    </tbody>
    <tbody v-else class="nodatas">
      <tr>
        <td :colspan="columns.length + emptyTr">
          <slot :name="'empty'" :text="'Empty Page'"></slot>
        </td>
      </tr>
    </tbody>
  </table>
  <slot :name="'contextMenu'" :position="state.position"></slot>
</section>